import { setAppCode, setPlatformCode } from '@micun/web-components'

setAppCode('cbs')
setPlatformCode('web')
